export const CHAPTER_LIST = `
query($bookId: Int!) {
  chapterList(bookId: $bookId) {
    total
    completed
    list {
      id
      name
      isAvailable
      isExperience
    }
  }
}`;

export const SECTION_LIST = `
query($chapterId: Int!) {
  sectionList(chapterId: $chapterId) {
    status
    total
    knowledgeTotal
    score
    isHasVideo
    list {
      id
      name
      progress
      status
      isAvailable
      isExperience
      isExistKnowledge
      wkVideo {
        name
        src
        poster
        videoDone
        quizzes {
          question
          options
          type
          answer
          time
        }
      }
    }
  }
}`;

export const EXAM_LIST = `
query($bookId: Int!, $pageSize: Int, $pageNumber: Int, $query: String) {
  examList(bookId: $bookId, pageSize: $pageSize, pageNumber: $pageNumber, query: $query) {
    total
    list {
      id
      name
      time
      duration
      score
    }
  }
}`;

export const PARALLEL_EXAM_LIST = `
query($catalogId: Int!, $pageSize: Int, $pageNumber: Int, $query: String, $type: String) {
  parallelExamList(catalogId: $catalogId, pageSize: $pageSize, pageNumber: $pageNumber, query: $query, type: $type) {
    total
    list {
      id
      name
      time
      duration
      score
    }
  }
}`;

export const LEARN_DATA = `
query ($type: String!, $catalogId: Int, $courseId: Int, $examId: Int, $action: String, $mode: String, $unitId: Int, $count: Int, $projectCode: String, $overviewId: Int) {
  dsCourseData(type: $type, catalogId: $catalogId, courseId: $courseId, examId: $examId, action: $action, mode: $mode, unitId: $unitId, count: $count, projectCode: $projectCode, overviewId: $overviewId) {
    id
    type
    status
    title
    navigation
    subtitle
    description
    isBacktrack
    isExam
    quizzes {
      id
      code
      title
      image
      explain
      ... on CourseQuizZsd {
        text
        wrongAnswer
      }
      ... on CourseQuizDx {
        options
        answer
        answerIndex
        question
        wrongAnswer
      }
    }
    answeredList {
      id
      answer
    }
  }
}`;

export const SUBMIT = `
mutation ($id: Int!, $seconds: Int, $quizzes: String!, $isBacktrack: Int, $type: String, $mode: String, $projectCode: String) {
  submitDsResult(id: $id, seconds: $seconds, quizzes: $quizzes, isBacktrack: $isBacktrack, type: $type, mode: $mode, projectCode: $projectCode)
}`;
